// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"411":"5192a7c5","472":"5192a7c5","714":"5192a7c5","829":"5192a7c5","974":"5192a7c5"}[chunkId] + ".chunk.css";
};